import type { MouseEvent } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import LinkButton from '_components/UI/LinkButton';

import type { BrandTile } from '../types';

import styles from './BrandCard.module.scss';

export interface BrandCardProps extends Omit<BrandTile, 'url' | 'coOpBrand'> {
  href: string;
  priority?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const BrandCard = ({
  href,
  logo,
  image,
  ctaLabel,
  priority = false,
  onClick,
}: BrandCardProps) => {
  const { t } = useTranslation('common');

  return (
    <a href={href} className={styles.card} onClick={onClick}>
      <span className={styles.imageWrapper}>
        <Image
          src={image.url}
          alt=""
          fill
          sizes="(min-width: 988px) 342px, 179px"
          priority={priority}
          className={styles.image}
        />
      </span>
      <span className={styles.overlay} aria-hidden="true" />
      <span className={styles.logo}>
        <Image
          src={logo.url}
          alt={logo.alt}
          fill
          sizes="(min-width: 988px) 242px, 131px"
          className={styles.logoImage}
        />
      </span>
      <span className={styles.ctaWrapper} aria-hidden="true">
        <LinkButton as="span" variant="white">
          {ctaLabel || t('brandTiles.shopNow')}
        </LinkButton>
      </span>
    </a>
  );
};

export default BrandCard;
